import { useApp } from "../context";
import { BANKS, today, offset } from "../lib/engine";

const Field = ({ label, ...props }) => (
  <label>{label}<input data-testid={`new-case-${props.name}`} {...props} /></label>
);

export default function NewCase() {
  const { state, actions, closeModal } = useApp();
  return (
    <>
      <h2>Create loan case</h2>
      <p className="muted">Use fictional information only.</p>
      <form data-testid="new-case-form" onSubmit={actions.createCase}>
        <div className="formgrid">
          <Field label="Borrower name" name="name" required maxLength={80} />
          <label>Partner
            <select name="partner" data-testid="new-case-partner">
              {state.partners.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </label>
          <label>Bank
            <select name="bank" data-testid="new-case-bank">
              {BANKS.map(b => <option key={b}>{b}</option>)}
            </select>
          </label>
          <Field label="City" name="city" defaultValue="Bengaluru" required maxLength={50} />
          <Field label="Unique lender reference" name="ref" required maxLength={60} />
          <Field label="Disbursement amount in INR" name="amount" type="number" min="10000" max="100000000" step="1" defaultValue="5000000" required />
          <Field label="Bank commission %" name="bankRate" type="number" min="0.01" max="10" step="0.01" defaultValue="1" required />
          <Field label="DSA entitlement %" name="dsaRate" type="number" min="0.01" max="10" step="0.01" defaultValue="0.7" required />
          <Field label="Disbursement date" name="date" type="date" defaultValue={today()} max={today()} required />
          <Field label="Commission due date" name="due" type="date" defaultValue={offset(30)} required />
          <label className="full">
            <input name="verified" type="checkbox" data-testid="new-case-verified" /> Simulate verified disbursement evidence
          </label>
        </div>
        <p className="notice space">
          The demo saves an agreement snapshot on creation.
          It models one tranche per case and excludes taxes and withholding.
        </p>
        <div className="footer">
          <button type="button" data-testid="new-case-cancel-btn" onClick={closeModal}>Cancel</button>
          <button type="submit" className="primary" data-testid="new-case-submit-btn">Create case</button>
        </div>
      </form>
    </>
  );
}
